.greenStripedRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(
        45deg,
        var(--ax-success-400) 0%,
        var(--ax-success-400) 25%,
        white 25%,
        white 40%,
        var(--ax-success-400) 40%,
        var(--ax-success-400) 60%,
        white 60%,
        white 75%,
        var(--ax-success-400) 75%,
        var(--ax-success-400) 100%,
        white 100%
    ) !important;
    border: 2px solid var(--ax-success-500) !important;
    print-color-adjust: exact;
}

.blueStripedRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(
        45deg,
        var(--ax-accent-400) 0%,
        var(--ax-accent-400) 25%,
        white 25%,
        white 40%,
        var(--ax-accent-400) 40%,
        var(--ax-accent-400) 60%,
        white 60%,
        white 75%,
        var(--ax-accent-400) 75%,
        var(--ax-accent-400) 100%,
        white 100%
    ) !important;
    border: 2px solid var(--ax-accent-500) !important;
    print-color-adjust: exact;
}

.lightblueGreenRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(
        to top,
        var(--ax-success-200),
        var(--ax-success-200) 50%,
        var(--ax-accent-400) 50%,
        var(--ax-accent-400) 100%
    ) !important;
    border: 2px solid var(--ax-success-200) !important;
    print-color-adjust: exact;
}

.lightgreenBlueRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(
        to top,
        var(--ax-accent-400),
        var(--ax-accent-400) 50%,
        var(--ax-success-200) 50%,
        var(--ax-success-200) 100%
    ) !important;
    border: 2px solid var(--ax-accent-400) !important;
    print-color-adjust: exact;
}

.blueOutlineRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid var(--ax-accent-500) !important;
    print-color-adjust: exact;
}

.beigeOutlineRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid var(--ax-brand-beige-600) !important;
    print-color-adjust: exact;
}

.blackOutlineRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid var(--ax-bg-neutral-strong) !important;
    print-color-adjust: exact;
}

.greenWithBlackOutlineDayRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background-color: var(--ax-success-400);
    border: 2px solid var(--ax-bg-neutral-strong) !important;
    print-color-adjust: exact;
}

.blueWithBlackOutlineDayRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background-color: var(--ax-accent-400);
    border: 2px solid var(--ax-bg-neutral-strong) !important;
    print-color-adjust: exact;
}

.greenOutlineRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid var(--ax-success-400) !important;
    print-color-adjust: exact;
}

.blackRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background-color: var(--ax-neutral-900) !important;
    print-color-adjust: exact;
}

.greenRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid var(--ax-success-600);
    background-color: var(--ax-success-400);
    print-color-adjust: exact;
}

.blueRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid var(--ax-accent-600);
    background-color: var(--ax-accent-400);
    print-color-adjust: exact;
}

.grayRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid var(--ax-neutral-500);
    background-color: var(--ax-neutral-100) !important;
    print-color-adjust: exact;
}
.darkgrayRect {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid var(--ax-neutral-500);
    background-color: var(--ax-neutral-400) !important;
    print-color-adjust: exact;
}
